module.exports = __webpack_public_path__ + "img/edit.53c12bf4.svg";